<template>
  <div class="row notintro">
    <div class="col-m-12">
      <fieldset class="form__field-group">
        <legend class="h4">
          Velg kundetype
          <question-icon @onClick="showModal = true">
            Trenger du hjelp?
          </question-icon>
        </legend>
        <div class="selectable-boxes-container">
          <div
            class="selectable-boxes"
            :class="{
              selected: selectedCustomerType.value === customerType.value,
            }"
            :key="customerType.id"
            v-for="customerType in customerTypes"
            @click="selectCustomerType(customerType)"
          >
            <div>{{ customerType.name }}</div>
            <div class="selectable-boxes-secondary-text">
              {{ customerType.description }}
            </div>
            <i class="material-icons">check</i>
          </div>
        </div>
      </fieldset>
    </div>

    <div
      class="modal"
      :class="{ 'is-visible': showModal }"
      id="modal1"
      @keyup.esc="showModal = false"
      @click.self="showModal = false"
      tabindex="0"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          Enova-støtte
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="showModal = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content">
          <legend class="h5">Privat</legend>
          <p>
            Privatpersoner har rett på støtte fra Enova. Se
            <a
              href="https://www.enova.no/privat/alle-energitiltak/solenergi/el-produksjon-/"
              target="_blank"
              >Enova</a
            >
            for mer info.
          </p>
          <legend class="h5">Bedrift</legend>
          <p>Bedrifter har ikke rett på støtte fra Enova.</p>
          <legend class="h5">Landbruk (næringsvirksomhet)</legend>
          <p>
            Landbrukskunder som er næringsvirksomhet har ikke rett på støtte fra
            Enova.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import QuestionIcon from './QuestionIcon.vue';

export default {
  name: 'MobilePriceDrilldown',
  components: {
    QuestionIcon,
  },
  data() {
    return {
      customerTypes: [
        {
          id: 1,
          name: 'Privat',
          value: 'privat',
        },
        {
          id: 2,
          name: 'Bedrift',
          value: 'bedrift',
        },
        {
          id: 3,
          name: 'Landbruk',
          description: 'Næringsvirksomhet',
          value: 'landbruk',
        },
      ],
      showModal: false,
    };
  },
  methods: {
    selectCustomerType: function(customerType) {
      store.commit('setCustomerType', customerType);
    },
  },
  computed: {
    selectedCustomerType() {
      return store.state.CustomerType;
    },
  },
};
</script>

<style scoped></style>
